import { Analytics, logEvent } from "@firebase/analytics"
import { useCallback, useEffect, useState } from "react"
import { getFirebaseAnalytics } from "../services/firebase"

import splitbee from "@splitbee/web"

export function useAnalytics() {
    const [analytics, setAnalytics] = useState<Analytics | null>(null)

    useEffect(() => {
        ;(async () => {
            const analytics = await getFirebaseAnalytics()
            setAnalytics(analytics)
        })()
    }, [])

    const _logEvent = useCallback(
        async (eventName: string, params?: { [key: string]: any }) => {
            splitbee.track(eventName, params)
            if (analytics) {
                console.log("[analytics] logging event: ", eventName, params)
                return logEvent(analytics, eventName, params || {})
            }
        },
        [analytics, splitbee]
    )

    return { analytics, logEvent: _logEvent }
}
